module.exports = __webpack_public_path__ + "static/media/distortion_sl_init.32bf9729.png";